import { PricingTier, SubscriptionPlan } from '../components/pages/home/types';

export const pricingPlans: PricingTier[] = [
    {
        id: SubscriptionPlan.PAY_AS_YOU_GO,
        name: 'Pay as you go',
        price: 5,
        priceUnit: '/hour/language',
        description: 'Perfect for smaller churches or occasional use',
        features: [
            'Unlimited amount of listeners',
            'All languages included',
            'Pay only when you speak',
        ],
        buttonText: 'Start free trial',
        highlighted: false,
    },
];

// Helper to format price for display
export const formatPlanPrice = (plan: PricingTier): string => {
    return `$${plan.price}${plan.priceUnit}`;
};
